$(document).ready(function() {
  const mainlandStatesUS = [
    "AL", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
    "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
    "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
    "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
    "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
  ];

  // Use sessionStorage to store location info
  const geoData = sessionStorage.getItem('geoData');

  if (geoData) {
    const parsedData = JSON.parse(geoData);
    processGeo(parsedData);
  } else {
    $.get("https://www.cloudflare.com/cdn-cgi/trace", function(traceData) {
      const ipLine = traceData.split('\n').find(line => line.startsWith('ip='));
      const ip_address = ipLine ? ipLine.substring(3) : '';

      $.getJSON("https://ipgeolocation.abstractapi.com/v1/?api_key=03af250bd0ad46f8abda91051d35dd76&ip_address=" + ip_address, function(locationData) {
        sessionStorage.setItem('geoData', JSON.stringify(locationData));
        processGeo(locationData);
      });
    });
  }

  function processGeo(data) {
    const isUS = data.country === 'United States';
    const isMainland = mainlandStatesUS.includes(data.region_iso_code);

    // Determine delivery date range
    let firstDate = new Date();
    let lastDate = new Date();

    if (isUS && isMainland) {
      firstDate.setDate(firstDate.getDate() + 5);
      lastDate.setDate(lastDate.getDate() + 15);
    } else {
      firstDate.setDate(firstDate.getDate() + 8);
      lastDate.setDate(lastDate.getDate() + 30);
    }

    const formattedFirstDate = formatDate(firstDate);
    const formattedLastDate = formatDate(lastDate);
    const dateRangeText = `${formattedFirstDate} - ${formattedLastDate}`;
    const hiddenInputValue = `${formattedFirstDate} and ${formattedLastDate}`;

    const appendHTML = `<div class='appenddatahere gb-hide-first-date'>
      <img class='gs-truck-icon' src='https://cdn.shopify.com/s/files/1/2469/4153/files/truck_02.png?v=1629817574'>
      Estimated between &nbsp;${dateRangeText}
    </div>`;
    const hiddenInput = `<input id="estimated-delivery-date" type="hidden" name="properties[Estimated delivery date]" value="${hiddenInputValue}">`;

    const $targets = $(".fg-add, #AddToCart, button.add-cart-btn.btn.AddToCart, ul#featured .product-detail form > a.add-cart-btn.btn-medium, .product-button .variants a.add-cart-btn, .add-cart, #add-cart");

    $targets.after(appendHTML + hiddenInput);

    $('body').on('DOMSubtreeModified', '#cart-drawer-inner', function() {
      $(".fg-add").after(appendHTML + hiddenInput);
    });

    // Check for mismatch and update cart line properties
    $(".prop_check").each(function() {
      const $el = $(this);
      const valcheck = $el.val();
      const dataline = $el.attr("data-line");

      if (valcheck !== formattedFirstDate) {
        $el.addClass("dontmatch");

        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          async: false,
          data: {
            line: dataline,
            properties: {
              'Estimated delivery date': hiddenInputValue
            }
          },
          dataType: 'json'
        });
      }
    });
  }

  // Helper function to format date
  function formatDate(date) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const day = date.getDate();
    const suffix = (day == 1 || day == 21 || day == 31) ? "st" :
                   (day == 2 || day == 22) ? "nd" :
                   (day == 3 || day == 23) ? "rd" : "th";
    return `${month}&nbsp;${day}${suffix}`;
  }
});
